import Layout from './Layout';
import SEOHead from './SEOHead';
import Welcome from './Home/Welcome';

export default function App() {
  return (
    <Layout>
      <SEOHead
        title="PEB & Prefab Industrial Buildings | Vasavi Structures"
        description="Vasavi Structures designs and builds PEB, prefab buildings, industrial sheds and steel fabrication in Hyderabad, delivered across Telangana and Andhra Pradesh."
        keywords="PEB manufacturer Hyderabad, pre-engineered buildings, prefab buildings, industrial sheds, steel fabrication, industrial sheds Telangana"
      />
      <Welcome />
    </Layout>
  );
}